import validate from "/home/runner/work/cpp/cpp/node_modules/nuxt/dist/pages/runtime/validate.js";
import abort_45navigation_45global from "/home/runner/work/cpp/cpp/middleware/abortNavigation.global.ts";
import add_45referrer_45global from "/home/runner/work/cpp/cpp/middleware/addReferrer.global.ts";
import mobile_45app_45view_45global from "/home/runner/work/cpp/cpp/middleware/mobileAppView.global.ts";
import trailing_45slash_45global from "/home/runner/work/cpp/cpp/middleware/trailing-slash.global.js";
import manifest_45route_45rule from "/home/runner/work/cpp/cpp/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  abort_45navigation_45global,
  add_45referrer_45global,
  mobile_45app_45view_45global,
  trailing_45slash_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}